import React from 'react';
function main() {
  return (
    <div>
      <div>안녕하세요. 프론트엔드 개발자 황다희입니다.</div>
      <br />
      <div>
        포트폴리오는 해당 페이지에서 확인가능합니다.
        <a href="http://portfolio.project-hh.com/">(링크)</a>
        <br />
        리스트는 여기에서 확인 가능합니다.
        <a href="http://http://portfolio.project-hh.com/about/naamezip/component">(링크)</a>
      </div>
    </div>
  );
}
export default main;

export const path = ['/', '/main'];
